<template>
	<div>
		<v-form ref="form" v-model="formIsValid" lazy-validation>
			<modal
				:exibir="exibir"
				:titulo="titulo"
				:max-width="450"
				:is-confirmar-visivel="true"
				:custom-actions="false"
				:acao-confirmar="verificarSePrecisaModalConfirmacao"
				nome-botao-confirmar="Salvar"
				:acao-cancelar="fecharModal"
				:is-confirmar-desabilitado="!formIsValid || erroObrigatoriedade || !temAnexoAdicionado"
				@close="fecharModal"
			>
				<template #body>
					<novo-anexo
						:infoAnexo="infoAnexo"
						:tipo-documento="tipoDocumentoList"
						:buscar-todos-tipos="buscarTodosTipos"
					></novo-anexo>
				</template>
			</modal>
		</v-form>
		<modal-confirmacao
			:exibir="exibirModalConfirmacao"
			:titulo-modal="infoModalConfirmacao.tituloModal"
			:mensagem="infoModalConfirmacao.mensagem"
			:mostrarAcaoConfirmar="true"
			@confirmar="confirmarModalConfirmacao"
			@fechar-modal="abriFecharModalConfirmacao"
		></modal-confirmacao>
	</div>
</template>
<script>
import NovoAnexo from '@/views/components/documentos/novo-anexo/NovoAnexo.vue'
import { mapState } from 'vuex'
import { mutationTypes } from '@/core/constants'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	components: { ModalConfirmacao, NovoAnexo },
	props: {
		infoAnexo: {
			type: Object,
			required: true,
		},
		exibir: {
			type: Boolean,
			required: true,
		},
		tipoDocumento: {
			type: [String, Array],
			required: true,
			validator: function (value) {
				return (
					typeof value === 'string' ||
					(Array.isArray(value) && value.every((item) => typeof item === 'string'))
				)
			},
		},
		infoModalConfirmacao: {
			type: Object,
			required: false,
			default: () => {
				return {
					tituloModal: '',
					mensagem: '',
					isModalConfirmacao: false,
				}
			},
		},
		buscarTodosTipos: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			formIsValid: false,
			exibirModalConfirmacao: false,
		}
	},
	computed: {
		...mapState({
			arquivoTemporario: (state) => state.campoArquivoNovo.arquivoTemporario,
			erroObrigatoriedade: (state) => state.campoArquivoNovo.erroObrigatoriedade,
			documentoAnexo: (state) => state.campoArquivoNovo.documentoComAnexo,
			validacaoDocuentoEnviado: (state) => state.campoArquivoNovo.validacaoDocuentoEnviado,
		}),

		titulo() {
			if (this.documento) {
				return 'Editar Anexo'
			}

			return 'Adicionar Anexo'
		},
		tipoDocumentoList() {
			if (typeof this.tipoDocumento === 'string') {
				return [this.tipoDocumento]
			} else if (Array.isArray(this.tipoDocumento)) {
				return this.tipoDocumento
			} else {
				return []
			}
		},
		temAnexoAdicionado() {
			return this.validacaoDocuentoEnviado
		},
	},
	methods: {
		async salvarAnexos() {
			if (this.arquivoTemporario) {
				await this.$emit('salvar-anexo')
				this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_DOCUMENTO_COM_ANEXOS)
			}
		},
		validarCamposPreenchidos() {
			this.$store.commit(
				mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ERRO_OBRIGATORIEDADE_ARQUIVO,
				!this.arquivoTemporario,
			)

			return this.$refs.form.validate() && !this.erroObrigatoriedade
		},
		verificarSePrecisaModalConfirmacao() {
			if (this.validarCamposPreenchidos()) {
				if (this.infoModalConfirmacao.isModalConfirmacao) {
					this.abriFecharModalConfirmacao()
				} else {
					this.confirmar()
				}
			}
		},
		async confirmar() {
			await this.salvarAnexos()
			this.fecharModal()
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		confirmarModalConfirmacao() {
			this.abriFecharModalConfirmacao()
			this.confirmar()
		},
		abriFecharModalConfirmacao() {
			this.exibirModalConfirmacao = !this.exibirModalConfirmacao
		},
	},
}
</script>
